import styled from '@emotion/styled'
import {COLORS} from '../constants'

/** A titled block of label/value rows below the KPI tiles (Offer Details, Ownership). */
export const Section = styled.section`
  margin-top: 14px;
`

/** Small uppercase caption heading a detail section, matching the KPI panel heading. */
export const SectionHeading = styled.div`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${COLORS.mutedText};
  margin-bottom: 8px;
`

/** The rows, laid out as responsive label/value pairs that wrap from two columns to one. */
export const List = styled.dl`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 6px 16px;
  margin: 0;
`

/** One label/value pair, label on the left, value right-aligned so figures line up. */
export const Row = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 3px 0;
  border-bottom: 1px solid ${COLORS.border};
`

/** The row's label term. */
export const RowLabel = styled.dt`
  font-size: 12px;
  color: ${COLORS.mutedText};
`

/** The row's value; wraps rather than overflowing the card. */
export const RowValue = styled.dd`
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: ${COLORS.foreground};
  text-align: right;
  min-width: 0;
  overflow-wrap: anywhere;
`
